<app-tb-picker
    class="w-full inline-flex"
    [itemTemplate]="item"
    (selectItem)="selectColor($event)"
    titleKey="color_title"
    [subtitle]="subtitle()"
    [name]="name()"
    [items]="pickerItems"
>
    <div
        trigger
        #triggerItem
        [class]="name() ? 'name-color-item' : 'cursor-pointer w-5 h-5 m-2 rounded-md'"
        [style.background-color]="selectedColor"
    ></div>
</app-tb-picker>

<ng-template #item let-item>
    <div
        class="flex items-center justify-center hover:border-primaryLight border-2 cursor-pointer rounded-[0.5625rem] w-[38px] h-[38px]"
        [class]="selectedColor === item ? 'border-text hover:border-text' : 'border-transparent'"
    >
        <div class="cursor-pointer rounded-lg w-8 h-8" [style.background-color]="item"></div>
    </div>
</ng-template>
